module.exports = __webpack_public_path__ + "img/stateDisAct.23d1d50c.svg";